import { render, staticRenderFns } from "./PocketMoney.vue?vue&type=template&id=6e0f6ae2&scoped=true&"
import script from "./PocketMoney.vue?vue&type=script&lang=js&"
export * from "./PocketMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0f6ae2",
  null
  
)

export default component.exports